import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromDataServices from '../data-services';

@Injectable({
    providedIn: 'root'
})
export class BudgetUploadService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uploadUri = `${environment.apiLocation}/BudgetUpload`;

    public uploadBudgets(JsonString: string): Observable<any> {
        this.log.verbose({
            type: 'BudgetUploadService:uploadBudgets',
            uri: this.uploadUri
        });
        return this.http
            .post<any>(this.uploadUri, {
                JsonString: JsonString
            })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'BudgetUploadService:response',
                        res
                    })
                )
            );
    }
    public deleteBudget(
        TxnId: number,
        BudgetStartDate: Date,
        BudgetEndDate
    ): Observable<any> {
        this.log.verbose({
            type: 'BudgetUploadService:deleteBudget',
            uri: this.uploadUri
        });
        return this.http
            .delete<fromDataServices.ProjectBudget.ProjectBudget>(
                `${environment.apiLocation}/ProjectBudget`,
                {
                    body: {
                        TxnId: TxnId,
                        BudgetStartDate: BudgetStartDate,
                        BudgetEndDate: BudgetEndDate
                    }
                }
            )
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'BudgetUploadService:response',
                        res
                    })
                )
            );
    }
}
